import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Card from '@material-ui/core/Card'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Button from '@material-ui/core/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import surveyQuestionApiService from '../../providers/survey/surveyQuestionApiService'

import './RatingQuestionsStyles.css'

/**
 * Rating Questions - category list.
 *
 * Mirrors the Assessment Forms list: one row per stock type category (Kind),
 * with an Edit button that opens the questions for that category.
 */
class RatingQuestionsList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      categories: [],
      loaded: false
    }
  }

  async componentDidMount () {
    const categories = await surveyQuestionApiService.getCategories()
    this.setState({ categories, loaded: true })
  }

  render () {
    const { categories, loaded } = this.state

    return (
      <div>
        <p className='page-title'>Rating Questions</p>
        <Card className='rating-questions-list'>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Category</TableCell>
                <TableCell>Questions</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {loaded && categories.length === 0 &&
                <TableRow>
                  <TableCell colSpan={3}>No categories found.</TableCell>
                </TableRow>}
              {categories.map(category => (
                <TableRow key={category._id}>
                  <TableCell className='category-name'>{category.title}</TableCell>
                  <TableCell>{category.questionCount}</TableCell>
                  <TableCell className='row-actions'>
                    <Button
                      color='primary'
                      component={Link}
                      to={`/rating-questions/${category._id}`}
                    >
                      <FontAwesomeIcon icon='list-ul' className='edit-icon' />
                      Edit
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    )
  }
}

export default RatingQuestionsList
